import { inject, Injectable } from '@angular/core';
import { UserStore } from '@lib/user/data-access';
import { hasScopes, matchEnvironment } from '@shared/utils/helpers';
import { TabWithPermissions } from '@shared/utils/interfaces';

@Injectable({ providedIn: 'root' })
export class AllowedTabsService {
  private readonly userStore = inject(UserStore);

  getAllowedTabs(tabs: TabWithPermissions[]): TabWithPermissions[] {
    return tabs.filter((tab) => {
      const hasAccess = hasScopes(tab.scopes!, this.userStore.scope());
      return hasAccess && matchEnvironment(tab.environment);
    });
  }
}
